import { Container, Form, Row, Col, InputGroup, ButtonGroup, Button, Modal, FloatingLabel, Image } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import d4k from 'src/cards/d4k.json';
import starter from 'src/cards/starter.json';
import alleluia from 'src/cards/alleluia.json';
import stardust from 'src/cards/stardust.json';
import ekklesia from 'src/cards/ekklesia.json';
import treasure from 'src/cards/treasure.json';
import merrisia from 'src/cards/merrisia.json';
import Filter from 'src/Filter';
import DeckManager from 'src/DeckManager';
import ImageModal from 'src/components/ImageModal';


const Home = () => {

  const AnnouncementModal = (props) => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            ประกาศจาก SMNDB
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            ฐานข้อมูลชุดนี้ถูกพัฒนาต่อโดย Official Summoner Master แล้ว
          </p>
          <p>
            หากพบเห็นการทำงานที่ผิดปกติของเว็บไซต์ / ต้องการติดตามข่าวสารเพิ่มเติม
          </p>
          
          <p>
            สามารถติดตามได้ที่ <a href='https://www.facebook.com/profile.php?id=100083705293032'>SMN New Era TeamAdmin</a>
          </p>
          <p>
            <h5>Update 24/10/2569 : Alleluia (6ใบ)</h5>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const navigate = useNavigate();
  const data = [].concat(d4k, starter, stardust, ekklesia, treasure, merrisia, alleluia);
  const initialStates = {
    type: 'all',
    pack: 'all',
    rarity: 'all',
    alpha: 'all',
    name: '',
    release: 'all',
    element: 'all',
    category: 'all',
    hashtag: '',
    mpSign: '===',
    mp: '',
    shrineSign: '===',
    shrine: '',
    attackSign: '===',
    attack: '',
    defenseSign: '===',
    defense: '',
    text: '',
    deckBuilderMode: false,
    cardsInDeck: 0,
  }
  // Cards to display
  const [cards, setCards] = React.useState(data);
  // Search criteria
  const [type, setType] = React.useState(initialStates.type);
  const [pack, setPack] = React.useState(initialStates.pack);
  const [rarity, setRarity] = React.useState(initialStates.rarity);
  const [alpha, setAlpha] = React.useState(initialStates.alpha);
  const [name, setName] = React.useState(initialStates.name);
  const [release, setRelease] = React.useState(initialStates.release);
  const [element, setElement] = React.useState(initialStates.element);
  const [category, setCategory] = React.useState(initialStates.category);
  const [hashtag, setHashtag] = React.useState(initialStates.hashtag);
  const [mpSign, setMpSign] = React.useState(initialStates.mpSign);
  const [mp, setMp] = React.useState(initialStates.mp);
  const [shrineSign, setShrineSign] = React.useState(initialStates.shrineSign);
  const [shrine, setShrine] = React.useState(initialStates.shrine);
  const [attackSign, setAttackSign] = React.useState(initialStates.attackSign);
  const [attack, setAttack] = React.useState(initialStates.attack);
  const [defenseSign, setDefenseSign] = React.useState(initialStates.defenseSign);
  const [defense, setDefense] = React.useState(initialStates.defense);
  const [text, setText] = React.useState(initialStates.text);

  const clear = (event) => {
    event.preventDefault();
    setType(initialStates.type);
    setPack(initialStates.pack);
    setRarity(initialStates.rarity);
    setAlpha(initialStates.alpha);
    setName(initialStates.name);
    setRelease(initialStates.release);
    setElement(initialStates.element);
    setCategory(initialStates.category);
    setHashtag(initialStates.hashtag);
    setMpSign(initialStates.mpSign);
    setMp(initialStates.mp);
    setShrineSign(initialStates.shrineSign);
    setShrine(initialStates.shrine);
    setAttackSign(initialStates.attackSign);
    setAttack(initialStates.attack);
    setDefenseSign(initialStates.defenseSign);
    setDefense(initialStates.defense);
    setText(initialStates.text);
    setCards([]); //setCards(data);
  }

  const search = (event) => {
    event.preventDefault();
    const result = data.filter(card => {
      if (
        Filter.checkType(type, card.type) &&
        Filter.checkPack(pack, card.pack) &&
        Filter.checkRarity(rarity, card.rarity) &&
        Filter.checkAlpha(alpha, card.alpha) &&
        Filter.checkName(name, card.name) &&
        Filter.checkRelease(release, card.release) &&
        Filter.checkElement(element, card.element) &&
        Filter.checkCategory(category, card.category) &&
        Filter.checkHashtag(hashtag, card.tag) &&
        Filter.checkMp(mp, mpSign, card.mp) &&
        Filter.checkShrine(shrine, shrineSign, card.shrine) &&
        Filter.checkAttack(attack, attackSign, card.attack) &&
        Filter.checkDefense(defense, defenseSign, card.defense) && 
        Filter.checkText(text, card.ability, card.skill)
      ){
        return true;
      }
      return false;
    });
    setCards(result);
  }

  // Modal
  const [modalAnnouncementShow, setModalAnnouncementShow] = React.useState(false);
  const [modalImageShow, setModalImageShow] = React.useState(false);
  const [modalImageSrc, setModalImageSrc] = React.useState("");

  // Deck Builder
  const [deckBuilderMode, setDeckBuilderMode] = React.useState(initialStates.deckBuilderMode);
  const [cardsInDeck, setCardsInDeck] = React.useState(initialStates.cardsInDeck);

  const addCard = (card, qty) => {
    if (DeckManager.addCardToDeck(card, qty)){
      setCardsInDeck(cardsInDeck + qty);
    }
  }

  const viewDeck = () => {
    navigate("/deck");
  }

  // Run on page load
  useEffect(() => {
    setModalAnnouncementShow(true);
    let numberOfCards = DeckManager.getCardsInDeck().reduce((acc, {qty}) => acc + qty, 0);
    setCardsInDeck(numberOfCards);
  }, []);




  return (
    <Container fluid className="bg">
      <AnnouncementModal
        show={modalAnnouncementShow}
        onHide={() => setModalAnnouncementShow(false)}
      />
      <ImageModal
        show={modalImageShow}
        src={modalImageSrc}
        onClick={() => setModalImageShow(false)}
        onHide={() => setModalImageShow(false)}
      />
      <h1 className="text-center">SMNDB</h1>
      <h2 className="text-center">Summoner Master New Era Database</h2>
      <p className="text-center">สามารถเข้าสู่โหมดจัดเด็คได้ที่ด้านล่าง</p>
      <Form onSubmit={(event) => search(event)}>
        <Row xs={2} lg={4}>
          <Form.Group as={Col}>
            <FloatingLabel label="ประเภท / Type">
              <Form.Control
                as="select"
                value={type}
                onChange={(e) => setType(e.target.value)} >
                <option value="all">ทุกประเภท / All</option>
                <option value="seal">ซีล / Seal</option>
                <option value="mystic">มิสติก / Mystic</option>
                <option value="heart">หัวใจ / Master's Heart</option>
              </Form.Control>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="แพ็ค / Pack">
              <Form.Control
                as="select"
                value={pack}
                onChange={(e) => setPack(e.target.value)} >
                <option value="all">All</option>
                <option value="D4K">D4K</option>
                <option value="Starter">Starter</option>
                <option value="Stardust">Stardust</option>
                <option value="Ekklesia">Ekklesia</option>
                <option value="Treasure">Treasure</option>
                <option value="Merrisia">Lineage of Merrisia</option>
                <option value="Alleluia">Alleluia</option>
              </Form.Control>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="ชื่อ / Name">
              <Form.Control
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyPress={event => event.key === 'Enter' && search(event)}
                type="text" />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            { pack !== "Alleluia" && <FloatingLabel label="ชุด / Release">
              <Form.Control
                as="select"
                value={release}
                onChange={(e) => setRelease(e.target.value)} >
                <option value="all">All</option>
                <option value="D4K-Starter">D4K Starter</option>
                <option value="D4K-Booster">D4K Booster</option>
                <option value="D4K-Challenger-01">D4K Challenger 01 (Bug)</option>
                <option value="D4K-Challenger-02">D4K Challenger 02 (Griffin)</option>
                <option value="D4K2-Booster">D4K2 Booster</option>
                <option value="D4K3-Booster">D4K3 Booster</option>
                <option value="Ekklesia-Booster">Ekklesia Booster</option>
                <option value="Ekklesia2-Booster">Ekklesia2 Booster</option>
                <option value="Stardust-Booster">Stardust Booster</option>
                <option value="Stardust2-Booster">Stardust2 Booster</option>
                <option value="Stardust3-Booster">Stardust3 Booster</option>
                <option value="Stardust4-Booster">Stardust4 Booster</option>
                <option value="Treasure1">Treasure1</option>
                <option value="Treasure2">Treasure2</option>
                <option value="Merrisia-Booster">Lineage of Merrisia Booster</option>
              </Form.Control>
            </FloatingLabel>}
          </Form.Group>
          { (type === "all" || type === "seal") && 
            <Form.Group as={Col}>
              <FloatingLabel label="ธาตุ / Element">
                <Form.Control
                  as="select"
                  value={element}
                  onChange={(e) => setElement(e.target.value)} >
                  <option value="all">ทุกธาตุ / All</option>
                  <option value="earth">ดิน / Earth</option>
                  <option value="water">น้ำ / Water</option>
                  <option value="wind">ลม / Wind</option>
                  <option value="fire">ไฟ / Fire</option>
                  <option value="light">แสง / Light</option>
                  <option value="dark">มืด / Dark</option>
                </Form.Control>
              </FloatingLabel>
            </Form.Group>
          }
          { (type === "mystic") && 
            <Form.Group as={Col}>
              <FloatingLabel label="หมวดหมู่ / Category">
                <Form.Control
                  as="select"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)} >
                  <option value="all">ทุกหมวดหมู่ / All</option>
                  <option value="tarot">Tarot</option>
                  <option value="relic">Relic</option>
                  <option value="devas">Devas</option>
                  <option value="place">Place</option>
                  <option value="event">Event</option>
                </Form.Control>
              </FloatingLabel>
            </Form.Group>
          }
          <Form.Group as={Col}>
            <FloatingLabel label="#แฮชแท็ก / #Hashtag">
              <Form.Control
                value={hashtag}
                onChange={(e) => setHashtag(e.target.value)}
                onKeyPress={event => event.key === 'Enter' && search(event)}
                type="text" />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="ความหายาก / Rarity">
              <Form.Control
                as="select"
                value={rarity}
                onChange={(e) => setRarity(e.target.value)} >
                <option value="all">All</option>
                <option value="normal">Normal</option>
                <option value="rare">Rare</option>
                <option value="super rare">Super Rare</option>
                <option value="ultra rare">Ultra Rare</option>
              </Form.Control>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col}>
            <FloatingLabel label="อัลฟ่า / Alpha">
              <Form.Control
                as="select"
                value={alpha}
                onChange={(e) => setAlpha(e.target.value)} >
                <option value="all">All</option>
                <option value="non-alpha">Non-Alpha</option>
                <option value="alpha">Alpha</option>
              </Form.Control>
            </FloatingLabel>
          </Form.Group>
        </Row>
        <Row xs={2} lg={4}>
          <Form.Group as={Col} xs={12} md={6} lg={6}>
            <Form.Group as={Row}>
              { type !== "heart" && <InputGroup>
                <InputGroup.Text>ค่าร่าย / MP</InputGroup.Text>
                <Form.Control
                  as="select"
                  value={mpSign}
                  onChange={(e) => setMpSign(e.target.value)} >
                  <option value="===">เท่ากับ</option>
                  <option value=">">มากกว่า</option>
                  <option value="<">น้อยกว่า</option>
                </Form.Control>
                <Form.Control
                  value={mp}
                  onChange={(e) => setMp(e.target.value)}
                  onKeyPress={event => event.key === 'Enter' && search(event)}
                  type="number" />
              </InputGroup>}
            </Form.Group>
          </Form.Group>
          <Form.Group as={Col} xs={12} md={6} lg={6}>
            <Form.Group as={Row}>
              { (type === "all" || type === "seal") && <InputGroup>
                <InputGroup.Text>สุสาน / Shrine</InputGroup.Text>
                <Form.Control
                  as="select"
                  value={shrineSign}
                  onChange={(e) => setShrineSign(e.target.value)} >
                  <option value="===">เท่ากับ</option>
                  <option value=">">มากกว่า</option>
                  <option value="<">น้อยกว่า</option>
                </Form.Control>
                <Form.Control
                  value={shrine}
                  onChange={(e) => setShrine(e.target.value)}
                  onKeyPress={event => event.key === 'Enter' && search(event)}
                  type="number" />
              </InputGroup>}
            </Form.Group>
          </Form.Group>
          <Form.Group as={Col} xs={12} md={6} lg={6}>
            <Form.Group as={Row}>
              { (type === "all" || type === "seal") && <InputGroup>
                <InputGroup.Text>พลังโจมตี / Attack</InputGroup.Text>
                <Form.Control
                  as="select"
                  value={attackSign}
                  onChange={(e) => setAttackSign(e.target.value)} >
                  <option value="===">เท่ากับ</option>
                  <option value=">">มากกว่า</option>
                  <option value="<">น้อยกว่า</option>
                </Form.Control>
                <Form.Control
                  value={attack}
                  onChange={(e) => setAttack(e.target.value)}
                  onKeyPress={event => event.key === 'Enter' && search(event)}
                  type="number" />
              </InputGroup>}
            </Form.Group>
          </Form.Group>
          <Form.Group as={Col} xs={12} md={6} lg={6}>
            <Form.Group as={Row}>
              { (type === "all" || type === "seal") && <InputGroup>
                <InputGroup.Text>พลังป้องกัน / Defense</InputGroup.Text>
                <Form.Control
                  as="select"
                  value={defenseSign}
                  onChange={(e) => setDefenseSign(e.target.value)} >
                  <option value="===">เท่ากับ</option>
                  <option value=">">มากกว่า</option>
                  <option value="<">น้อยกว่า</option>
                </Form.Control>
                <Form.Control
                  value={defense}
                  onChange={(e) => setDefense(e.target.value)}
                  onKeyPress={event => event.key === 'Enter' && search(event)}
                  type="number" />
              </InputGroup>}
            </Form.Group>
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col}>
            <FloatingLabel label="Text / Ability & Skill">
              <Form.Control
                value={text}
                onChange={(e) => setText(e.target.value)}
                onKeyPress={event => event.key === 'Enter' && search(event)}
                type="text" />
            </FloatingLabel>
          </Form.Group>
        </Row>
      </Form>
      <Container fluid>
        <Row>
          <Col xs={12} sm={3}>
            <ButtonGroup className="d-flex">
              <Button variant="secondary" onClick={(event) => clear(event)}>ล้างค่า</Button>
            </ButtonGroup>
          </Col>
          <Col xs={12} sm={9}>
            <ButtonGroup className="d-flex">
              <Button variant="dark" onClick={(event) => search(event)}>ค้นหา</Button>
            </ButtonGroup>
          </Col>
        </Row>
      </Container><hr/>
      <Container fluid className="card-display-container">
        <Row>
          {cards.map(card =>
            <Col key={`${card.pack}-${card.id}`} xs={6} sm={4} md={3} lg={2}>
              <div>
                { card.type === "unknown" && <FloatingLabel className="text-on-image">{card.pack} {card.id}</FloatingLabel>}
                <Image 
                  className="card" 
                  src={`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`} 
                  onClick={() => {
                    setModalImageSrc(`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`);
                    setModalImageShow(true);
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src=`images/cards/unknown.jpg`;
                  }}
                  loading="lazy"/>
              </div>
              { deckBuilderMode && card.type !== "unknown" &&
                <Row>
                  <Col xs={12} sm={12}>
                    <ButtonGroup className="d-flex">
                      <Button variant="primary" className="plus-minus-button" onClick={(event) => addCard(card, -1)}>-</Button>
                      <Button variant="">{DeckManager.getNumberOfCardInDeck(card)} ใบ</Button>
                      <Button variant="primary" className="plus-minus-button" onClick={(event) => addCard(card, 1)}>+</Button>
                    </ButtonGroup>
                    <br/>
                  </Col>
                </Row>
              }
            </Col>
          )}
        </Row>
      </Container>
      <Container fluid className="footer">
        { !deckBuilderMode && 
          <Row>
            <Col xs={12} sm={12}>
              <ButtonGroup className="d-flex">
                <Button variant="primary" onClick={(event) => setDeckBuilderMode(true)}>เข้าสู่โหมดจัดเด็ค</Button>
              </ButtonGroup>
            </Col>
          </Row>
        }
        { deckBuilderMode && 
          <Row>
            <Col xs={12} sm={3}>
              <ButtonGroup className="d-flex">
                <Button variant="secondary" onClick={(event) => setDeckBuilderMode(false)}>ออกจากโหมดจัดเด็ค</Button>
              </ButtonGroup>
            </Col>
            <Col xs={12} sm={9}>
              <ButtonGroup className="d-flex">
                <Button variant="dark" onClick={(event) => viewDeck()}>ดูเด็ค ({cardsInDeck} ใบ)</Button>
              </ButtonGroup>
            </Col>
          </Row>
        }
      </Container>
    </Container>
  );
}


export default Home;